<template>
  <div class="c8-explanation__content">
    <p>1. “X”表示历史对应的某一期未出现该号码， “√”表示历史对应的某一期出现了该号码</p>
    <p>2. 路珠图展示近期每期的开奖结果，请从左到右、自上而下查看路珠图，当连续开出的同一形态中断时，则另起一列显示</p>
    <p>3. 表格最右一列为最新一期结果</p>
  </div>
</template>

<script>
export default {
  name: 'K3WebHaoMaLuJhu' // 號碼路珠
}
</script>
